import { Button, Flex, Input, Tag } from "antd";
import { useState } from "react";

type ReplyTarget = { id: number; name: string };

type CommentComposerProps = {
  onSubmit: (content: string, replyTo?: number) => Promise<void>;
  replyingTo: ReplyTarget | null;
  onClearReply: () => void;
};

export const CommentComposer = ({
  onSubmit,
  replyingTo,
  onClearReply,
}: CommentComposerProps) => {
  const [content, setContent] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async () => {
    const trimmed = content.trim();
    if (!trimmed) return;
    setSubmitting(true);
    try {
      await onSubmit(trimmed, replyingTo?.id);
      setContent("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Flex vertical gap={8}>
      {replyingTo && (
        <Tag
          closable
          onClose={onClearReply}
          style={{ width: "fit-content" }}
        >
          Replying to {replyingTo.name}
        </Tag>
      )}
      <Input.TextArea
        rows={3}
        placeholder="Write a comment..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />
      <Flex justify="flex-end">
        <Button
          type="primary"
          disabled={!content.trim()}
          loading={submitting}
          onClick={handleSubmit}
        >
          {replyingTo ? "Reply" : "Post Comment"}
        </Button>
      </Flex>
    </Flex>
  );
};
